// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"733":"polyfill~intersectionObserver","880":"polyfill~fetch"}[chunkId] || chunkId) + "-" + {"259":"00fd7fc0196bd0d5662e","733":"a89a0b80813451a32532","880":"97bcc603a2622e2c09e1"}[chunkId] + ".chunk.js";
};